import styled from "@mui/material/styles/styled";

export const ArrowWrapper = styled('span')({
    position: "absolute",
    right: 5,
    display: "inline-flex",
    top: "50%",
    transform: 'translateY(-50%)'
});

